import { LANGUAGES_LOCALIZED } from "@app/constant/languages-localized"
import { LanguageItem } from "../types/language.type"
export class LanguageUtil {
    /** */
    static LANGUAGES_NAME_MAP_LOCALIZED: Map<string, string> = new Map(
        LANGUAGES_LOCALIZED.map((languageItem: LanguageItem) => [languageItem.code.trim(), languageItem.label.trim()])
    )
}